import React from "react";
import Banner from "../../Section/Home/Banner/banner";
import Desktop from "../../Media/Office_Desktop.webp";
import Mobile from "../../Media/Office_Mobile.webp";
import About from "../../Section/Detail/about/about";
import Promo from "../../Section/Home/Promo/promo";
import Produk from "../Office/Office1/Office1";
import Lokasi from "../../Section/Home/Lokasi/lokasi";
import office from "./Office.json";

const poinioffice = [
  "Siap Huni",
  "Free DP",
  "Voucher Cashback Up To 270",
  "Free AC",
  "Easy Access",
  "High Potential Captive Market",
  "Surrounded by Many Residential",
];

const Office = () => {
  return (
    <div>
      <Banner Desktop={Desktop} Mobile={Mobile} />
      <About
        poin={office.point}
        judul={office.judul}
        Deskrisi={office.deskripsi}
      />
      <Promo poininvestment={poinioffice} />
      <Produk />
      <Lokasi />
    </div>
  );
};

export default Office;
